(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/pd-items-menu.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/pd-items-menu.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const {
  useLocation
} = ReactRouterDOM;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  Link
} = ReactRouterDOM;
const {
  routes
} = svs.myProfile.constants;
const {
  getCustomersPreferences
} = svs.myProfile.react.store.pdPreferences.actions;
const makeParams = cAndI => {
  const {
    c,
    i
  } = cAndI;
  if (!c || !i) {
    return '';
  }
  return "?c=".concat(c, "&i=").concat(i);
};

const PdItemsMenu = () => {
  const location = useLocation();
  const {
    cAndI
  } = ReactRedux.useSelector(state => state.playerDetails);
  const {
    playerCustomizedSettings
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings);
  const dispatch = ReactRedux.useDispatch();
  const params = makeParams(cAndI);
  const [pages, setPages] = useState(() => [{
    href: routes.MY_PROFILE_NOTIFICATIONS + params,
    iconName: 'notifications',
    label: 'Spelnotifieringar',
    altHrefs: [routes.MY_PROFILE_NOTIFICATIONS]
  }, {
    href: routes.MY_PROFILE_COMMUNICATION + params,
    iconName: 'e-post',
    label: 'Kommunikation',
    altHrefs: [routes.MY_PROFILE_COMMUNICATION, routes.MY_PROFILE_COMMUNICATION_ADAPT_CONTENT]
  }]);
  const branding = svs.core.config.data.svsconfig.site === 'momang' ? 'momang' : 'sport';
  useEffect(() => {
    dispatch(getCustomersPreferences());
  }, []);
  useEffect(() => {
    const isPlayerLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    if (isPlayerLoggedIn) {
      const newPages = pages.slice();
      const findUppgifter = pages.findIndex(p => p.href === routes.MY_PROFILE_HOME);
      if (findUppgifter === -1) {
        newPages.unshift({
          href: routes.MY_PROFILE_HOME,
          label: 'Mina\u{00A0}uppgifter',
          altHrefs: [routes.MY_PROFILE_INFORMATION, routes.MY_PROFILE_PLAYERDETAILS_CHANGE_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_MISSING_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_CHANGE_MOBILE, routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_MOBILE, routes.MY_PROFILE_TRANSCRIPT]
        });
      }
      const findKyc = pages.findIndex(p => p.href === routes.MY_PROFILE_KYC);
      if (findKyc === -1) {
        newPages.push({
          href: routes.MY_PROFILE_KYC,
          label: 'Kundkännedom',
          altHrefs: [routes.MY_PROFILE_KYC_QUESTIONS]
        });
      }
      setPages(newPages);
    }
  }, [playerCustomizedSettings === null || playerCustomizedSettings === void 0 ? void 0 : playerCustomizedSettings.showKyc]);
  return React.createElement(ItemsMenu, {
    branding: branding,
    centered: true,
    customer: "sport",
    useScrollFaders: true
  }, pages.map(_ref => {
    let {
      href,
      label,
      altHrefs
    } = _ref;
    return React.createElement(LinkItem, {
      alignment: "vertical",
      Component: Link,
      gutter: 1,
      id: "".concat(label.toLowerCase(), "Nav"),
      key: label,
      label: label,
      minwidth: 125,
      selected: (location === null || location === void 0 ? void 0 : location.pathname) === href || (altHrefs === null || altHrefs === void 0 ? void 0 : altHrefs.includes(location === null || location === void 0 ? void 0 : location.pathname)),
      to: href
    });
  }));
};
svs.myProfile.react.shared.components.PdItemsMenu = PdItemsMenu;

 })(window);